const data = [
  {
    "id": 1,
    "content": "Original Exploration Project of the National Natural Science Foundation of China: Research on Catastrophe Mechanism and Anti-Matthew Regulation Theory of Large-Scale Complex Networks, 2026.01 - 2026.12, Total Funding: 1 million yuan.",
    "language": "英语"
  },
  {
    "id": 2,
    "content": "Joint Fund for Enterprise Innovation and Development Project: Research on Key Technologies of Transient Twin for Large-scale and High-robustness Mobile Networks, 2026-2029, Total Funding: 2.59 million yuan",
    "language": "英语"
  },
  {
    "id": 3,
    "content": "Key Research Project of National Key R&D Program: Semantic-native ubiquitous intelligent and simple wireless networking method, 2025-2030, total budget of 27.86 million yuan (project budget of 4.2 million yuan)",
    "language": "英语"
  },
  {
    "id": 4,
    "content": "National Science Fund for Distinguished Young Scholars (62325208): Highly Reliable Industrial Internet of Things, 2024-2028.",
    "language": "英语"
  },
  {
    "id": 5,
    "content": "National Natural Science Foundation of China (62272339): Research on Robustness of Intelligent Sensing and Behavior Recognition for Wireless Channel State Information, 2023-2026.",
    "language": "英语"
  },
  {
    "id": 6,
    "content": "Research on Intelligent Analysis and Real Time Scheduling Technology for Heterogeneous Edge Data Flow in the Power Internet of Things, 2023-2023.",
    "language": "英语"
  },
  {
    "id": 7,
    "content": "Industrial control protocol identification and analysis method and data relation processing technology service project of industrial Internet attack behavior, 2022-2023.",
    "language": "英语"
  },
  {
    "id": 8,
    "content": "National Natural Science Foundation Project (2021B1-0169): Research on Key Technologies of End-Edge Collaborative Perception for Intelligent Connected Vehicles, 2021-2024.",
    "language": "英语"
  },
  {
    "id": 9,
    "content": "2021 Industrial Internet Innovation and Development Project - Time-sensitive Network Control System, 2021-2023.",
    "language": "英语"
  },
  {
    "id": 10,
    "content": "Zhejiang Lab (2021KF0AB02): A Study for Blockchain-based highly trusted scalable distributed storage mechanisms, 2021-2022.",
    "language": "英语"
  },
  {
    "id": 11,
    "content": "Tianjin Municipal Science and Technology Bureau (20JCJQJC00250): Networking Robustness Optimization and Transmission Strategy for Large-scale Smart Internet of Things, 2020-2024.",
    "language": "英语"
  },
  {
    "id": 12,
    "content": "National Key Research and Development Program Project (2019YFB1703600): Research on Theory and Methods of Non-deterministic Manufacturing Big Data in Flexible Systems，2020-2022.",
    "language": "英语"
  },
  
  {
    "id": 14,
    "content": "South China University of Technology (2019YFB1703601): Research on Big Data Theory and Method for Flexible System Non-deterministic Manufacturing, 2020-2022.",
    "language": "英语"
  },
  {
    "id": 15,
    "content": "National Natural Science Foundation Project (2018BQ-0097): Research on Physical Layer Security in Untrusted Relay Networks Based on Decode-and-Forward, 2018-2020.",
    "language": "英语"
  },
  {
    "id": 16,
    "content": "National Natural Science Foundation of China (61672131): Research on Robustness and Modeling for Large-Scale Heterogeneous Sensor Networks in Interent of Things, 2017-2020.",
    "language": "英语"
  },
  {
    "id": 17,
    "content": "Tianjin Youth Fund Project (2017FQ-0001): Research on Key Technologies of Wireless Mesh Networks Based on Network Coding, 2017-2020.",
    "language": "英语"
  },
  {
    "id": 18,
    "content": "National Natural Science Foundation of China (U2001204): Research on Key Technologies of Efficient and Secure Mobile Internet of Things for 5G and Future Networks, 2021-2023.",
    "language": "英语"
  },
  {
    "id": 19,
    "content": "National Key R&D Program Project: Academic Classification and Recommendation System Based on Stereoscopic Precise ImagingB.",
    "language": "英语"
  },
  {
    "id": 20,
    "content": "Tianjin Science and Technology Bureau Artificial Intelligence Major Project: Key Technology Research and Development and Application of Intelligent Mechanical Manufacturing Production Line.",
    "language": "英语"
  },
  {
    "id": 21,
    "content": "Tianjin Science and Technology Bureau Technology Achievement Transfer and Transformation Project: Demonstration Platform for Application Scenarios of Advanced Technologies in Industrial IoT for Intelligent Manufacturing.",
    "language": "英语"
  }
];

export default data;
